import { RootState } from 'common/redux/core/root.reducer';

export const getCompanyFootprintResponse = (state: RootState) =>
    state.dataManagement.companyFootprints;

export const getCompanyFootprintUpdateResponse = (state: RootState) =>
    state.dataManagement.updateCompanyFootprint;

export const getCompanyInfoResponse = (state: RootState) => state.dataManagement.companyInfo;

export const getCompanyInfoEditResponse = (state: RootState) =>
    state.dataManagement.updateCompanyInfo;
